// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum License {
    eNONE_MODUL=0,                              // 0
    e10_JAHRE_BEOBACHTUNGSZEITRAUM,             // 1
    eANLAGEN,                                   // 2
    eAUFTRAG,                                   // 3
    eBETEILIGUNGSKREISE,                        // 4
    eBILANZ_GUV,                                // 5
    eBUCHEN_AUF_VTSAETZE,                       // 6
    eBUCHUNGSEXPORT,                            // 7
    eBUCHUNGSIMPORT,                            // 8
    eBUCHUNGSPERIODEN,                          // 9
    eBWA,                                       // 10
    eCENTER,                                    // 11
    eDAUERBUCHUNGEN,                            // 12
    eEA_AUS_BILANZ,                             // 13
    eEINZELSOLLBETRAEGE,                        // 14
    eERWEITERTER_LISTGENERATOR,                 // 15
    eERWEITERTE_INDEXVERWALTUNG,                // 16
    eE_BANKING,                                 // 17
    eFAKTURA,                                   // 18
    eFONDSVERWALTUNG,                           // 19
    eFREIE_MASKEN,                              // 20
    eFREIE_OBJEKTGRUPPENDEFINITION,             // 21
    eHKD,                                       // 22
    eHYPOTHEKEN,                                // 23
    eINTERESSENTEN,                             // 24
    eINTERN_PORTFOLIO,                          // 25
    eKAUTION,                                   // 26
    eKLEINES_FLAECHENMODELL,                    // 27
    eKONTENZINSBERECHNUNG,                      // 28
    eKOSTENSTELLEN_KOSTENTRAEGER,               // 29
    eLIS,                                       // 30
    eMIETANPASSUNG_NACH_MHG,                    // 31
    eMITGLIEDER_ALT,                            // 32
    eOEKOSTEUERBERECHNUNG,                      // 33
    ePROJEKTVERWALTUNG,                         // 34
    eRAUMBUCH,                                  // 35
    eSCHNITTSTELLE_ALLFA,                       // 36
    eSCHNITTSTELLE_DATEV,                       // 37
    eSCHNITTSTELLE_DMS,                         // 38
    eSCHNITTSTELLE_OFFICEWARE,                  // 39
    eSCHNITTSTELLE_ONLINEHOUSING,               // 40
    eSCHNITTSTELLE_PORTFOLIO,                   // 41
    eSEV_KONTOAUSZUG,                           // 42
    eSOLL_ISTANALYSE,                           // 43
    eSTANDARD_INDEXVERWALTUNG,                  // 44
    eSTANDARD_LISTGENERATOR,                    // 45
    eSTAPEL,                                    // 46
    eTO,                                        // 47
    eUMSATZMIETE,                               // 48
    eUNBESCHRAENKTE_DCL_ZEILEN,                 // 49
    eUNBESCHRAENKTE_FLAECHENVERWALTUNG,         // 50
    eUST_FLAECHENAUFTEILUNG,                    // 51
    eVERAENDERUNGSPROTOKOLL,                    // 52
    eVERWALTUNGSABRECHNUNG_GLOBAL,              // 53
    eZAHLSCHEINDRUCK,                           // 54
    eSERIENBRIEF_WORD,                          // 55
    eWEG_VERWALTUNG,                            // 56
    eTECHNISCHE_BESTANDSDOKUMENTATION,          // 57
    eCMR,                                       // 58
    eFREMD_WRNG,                                // 59
    eVA_PRINZIP_PERSON,                         // 60
    eQW_SOLLSTELLUNG,                           // 61
    eBESCHLUSSVERWALTUNG,                       // 62
    eRECHNUNGSEINGANGSBUCH,                     // 63
    eSCHNITTSTELLE_GDPDU,                       // 64
    eEXCEL_REPORTING,                           // 65
    eHKDE898,                                   // 66
    eFLOWFACT,                                  // 67
    ePRINTVIEWERPLUS,                           // 68
    eDATENBANKPROTOKOLL,                        // 69
    eKOMFORTPAKET,                              // 70
    eINABHINUNFRUECK,                           // 71
    eCASHFLOW,                                  // 72
    eEINZELWERTBERICHTIGUNG,                    // 73
    eTRIMAHNSCHNITTSTELLE,                      // 74
    eKOMFORTPAKETNURIS,                         // 75
    eVA_PRINZIP_KREDITOR,                       // 76
    eBENUTZERKOPPLUNG,                          // 77
    eMIETVERTRAGSSCHREIBUNG,                    // 78
    eDOCUWAREINTEGRATION,                       // 79
    eEBILANZ_SCHNITTSTELLE,                     // 80
    eDATEV_PREMIUM_SCHNITTSTELLE,               // 81
    eOS_DMS_OPTIMAL_SYSTEMS,                    // 82
    eVERWALTERGEBUEHRENABR,                     // 83
    eTAPI_SCHNITTSTELLE,                        // 84
    eKM_KAUTIONSSCHNITTSTELLE,                  // 85
    eVIRTUELLE_KONTEN,                          // 86
    eMITGLIEDERVERWALTUNG,                      // 87
    eRECHNUNGSIMPORT,                           // 88
    eMYIMMOCONNECT_MIETER,                      // 89
    eMYIMMOCONNECT_HAUSMEISTER,                 // 90
    eMYIMMOCONNECT_INVESTOR,                    // 91
    eUSTVA_ELSTER,                              // 92
    eKAUTION_ZAHLUNGSVERKEHR,                   // 93
    eCASAVI_MIETER,                             // 94
    eCASAVI_HAUSMEISTER,                        // 95
    eCASAVI_INVESTOR,                           // 96
    eIXDWVIEW,                                  // 97
    eEASYDMSINTEGRATION,                        // 98
    eSERDMSINTEGRATION,                         // 99
    eKONFIPAY,                                  // 100
    eDATEV_PREMIUM_DMSBELEGEXPORT,              // 101
    eDMS_SUCHE,                                 // 102
    eDMS_VERSCHLAGWORTUNG,                      // 103
    eDMS_API,                                   // 104
    eZAEHLERSTANDVERWALTUNG,                    // 105
    eKAUTION_ZAHLUNGSVERKEHR_DKB,               // 106
    ePROJEKT_RUECKSTELLUNGEN,                   // 107
    eWOHNUNGSUEBERGABE_ENTAB,                   // 108
    eERWERBERVERWALTUNG,                        // 109
    eBERICHTSPAKET_5BERICHTE,                   // 110
    eBERICHTSPAKET_10BERICHTE,                  // 111
    eBERICHTSPAKET_UNBEGRENZT,                  // 112
    eDATEV_SACHKONTEN_BUCHUNGSIMPORT,           // 113
    eCOVID19_RATE_STUNDUNG_KOMFORTLOESUNG,      // 114
    eZENSUS_PREMIUM,                            // 115
    eFEATUREPAKET_2020,                         // 116
    eFEATUREPAKET_2021,                         // 117
    eEGECKODMSINTEGRATION,                      // 118
    eDATEV_RECHNUNGSIMPORT,                     // 119
    eBISONBOX_EXPORT,                           // 120
    eSCHLUESSELVERWALTUNG,                      // 121
    eDYNTAB_M,                                  // 122
    eDYNTAB_L,                                  // 123
    eDYNTAB_XL,                                 // 124
    eHKD_SCHNITTSTELLE_EED,                     // 125
    eINTREAL_SCHNITTSTELLE_VERSION_4_5,         // 126
    eFEATUREPAKET_2022,                         // 127
    eCASAVI_EED,                                // 128
    eVA_PRINZIP_FLAECHE,                        // 129
    eGRUNDSTEUER_DATEN,                         // 130
    eGRUNDSTEUER_BERECHNUNG,                    // 131
    eGRUNDSTEUER_ELSTEREXPORT,                  // 132
    eWEBSERVICEHKDDOK,                          // 133
    eSCRIPTMENUERWEITERT,                       // 134
    eENERGIEAUSWEIS,                            // 135
    eDOCUWARECONNECT2IXHAUSCLOUD,               // 136
    eFEATUREPAKET_2023,                         // 137
    eDATEIUMSTELLUNGEXCEL,                      // 138
    eSCHNITTSTELLE_DATEV_WEBSERVICE,            // 139
    eFEATUREPAKET_2024,                         // 140
    eSEMPPM_SCHNITTSTELLE_VERSION_2_1,          // 141
    eSEMPPM_SCHNITTSTELLE_VERSION_2_3,          // 142
    eHANSAINVEST_SCHNITTSTELLE,                 // 143
    eVA_PRINZIP_PROJEKTBUDGET,                  // 144
    ePLATZHALTER_FUER_NEUE_LIZENZ,              // 145
    eSSO_LOGIN,                                 // 146
    eERECHNUNG_READY,                           // 147
}

export const LicenseLabels: {[k: string]: string} = {
    [License.eNONE_MODUL]: t('global:enum.License.eNONE_MODUL=0'),
    [License.e10_JAHRE_BEOBACHTUNGSZEITRAUM]: t('global:enum.License.e10_JAHRE_BEOBACHTUNGSZEITRAUM'),
    [License.eANLAGEN]: t('global:enum.License.eANLAGEN'),
    [License.eAUFTRAG]: t('global:enum.License.eAUFTRAG'),
    [License.eBETEILIGUNGSKREISE]: t('global:enum.License.eBETEILIGUNGSKREISE'),
    [License.eBILANZ_GUV]: t('global:enum.License.eBILANZ_GUV'),
    [License.eBUCHEN_AUF_VTSAETZE]: t('global:enum.License.eBUCHEN_AUF_VTSAETZE'),
    [License.eBUCHUNGSEXPORT]: t('global:enum.License.eBUCHUNGSEXPORT'),
    [License.eBUCHUNGSIMPORT]: t('global:enum.License.eBUCHUNGSIMPORT'),
    [License.eBUCHUNGSPERIODEN]: t('global:enum.License.eBUCHUNGSPERIODEN'),
    [License.eBWA]: t('global:enum.License.eBWA'),
    [License.eCENTER]: t('global:enum.License.eCENTER'),
    [License.eDAUERBUCHUNGEN]: t('global:enum.License.eDAUERBUCHUNGEN'),
    [License.eEA_AUS_BILANZ]: t('global:enum.License.eEA_AUS_BILANZ'),
    [License.eEINZELSOLLBETRAEGE]: t('global:enum.License.eEINZELSOLLBETRAEGE'),
    [License.eERWEITERTER_LISTGENERATOR]: t('global:enum.License.eERWEITERTER_LISTGENERATOR'),
    [License.eERWEITERTE_INDEXVERWALTUNG]: t('global:enum.License.eERWEITERTE_INDEXVERWALTUNG'),
    [License.eE_BANKING]: t('global:enum.License.eE_BANKING'),
    [License.eFAKTURA]: t('global:enum.License.eFAKTURA'),
    [License.eFONDSVERWALTUNG]: t('global:enum.License.eFONDSVERWALTUNG'),
    [License.eFREIE_MASKEN]: t('global:enum.License.eFREIE_MASKEN'),
    [License.eFREIE_OBJEKTGRUPPENDEFINITION]: t('global:enum.License.eFREIE_OBJEKTGRUPPENDEFINITION'),
    [License.eHKD]: t('global:enum.License.eHKD'),
    [License.eHYPOTHEKEN]: t('global:enum.License.eHYPOTHEKEN'),
    [License.eINTERESSENTEN]: t('global:enum.License.eINTERESSENTEN'),
    [License.eINTERN_PORTFOLIO]: t('global:enum.License.eINTERN_PORTFOLIO'),
    [License.eKAUTION]: t('global:enum.License.eKAUTION'),
    [License.eKLEINES_FLAECHENMODELL]: t('global:enum.License.eKLEINES_FLAECHENMODELL'),
    [License.eKONTENZINSBERECHNUNG]: t('global:enum.License.eKONTENZINSBERECHNUNG'),
    [License.eKOSTENSTELLEN_KOSTENTRAEGER]: t('global:enum.License.eKOSTENSTELLEN_KOSTENTRAEGER'),
    [License.eLIS]: t('global:enum.License.eLIS'),
    [License.eMIETANPASSUNG_NACH_MHG]: t('global:enum.License.eMIETANPASSUNG_NACH_MHG'),
    [License.eMITGLIEDER_ALT]: t('global:enum.License.eMITGLIEDER_ALT'),
    [License.eOEKOSTEUERBERECHNUNG]: t('global:enum.License.eOEKOSTEUERBERECHNUNG'),
    [License.ePROJEKTVERWALTUNG]: t('global:enum.License.ePROJEKTVERWALTUNG'),
    [License.eRAUMBUCH]: t('global:enum.License.eRAUMBUCH'),
    [License.eSCHNITTSTELLE_ALLFA]: t('global:enum.License.eSCHNITTSTELLE_ALLFA'),
    [License.eSCHNITTSTELLE_DATEV]: t('global:enum.License.eSCHNITTSTELLE_DATEV'),
    [License.eSCHNITTSTELLE_DMS]: t('global:enum.License.eSCHNITTSTELLE_DMS'),
    [License.eSCHNITTSTELLE_OFFICEWARE]: t('global:enum.License.eSCHNITTSTELLE_OFFICEWARE'),
    [License.eSCHNITTSTELLE_ONLINEHOUSING]: t('global:enum.License.eSCHNITTSTELLE_ONLINEHOUSING'),
    [License.eSCHNITTSTELLE_PORTFOLIO]: t('global:enum.License.eSCHNITTSTELLE_PORTFOLIO'),
    [License.eSEV_KONTOAUSZUG]: t('global:enum.License.eSEV_KONTOAUSZUG'),
    [License.eSOLL_ISTANALYSE]: t('global:enum.License.eSOLL_ISTANALYSE'),
    [License.eSTANDARD_INDEXVERWALTUNG]: t('global:enum.License.eSTANDARD_INDEXVERWALTUNG'),
    [License.eSTANDARD_LISTGENERATOR]: t('global:enum.License.eSTANDARD_LISTGENERATOR'),
    [License.eSTAPEL]: t('global:enum.License.eSTAPEL'),
    [License.eTO]: t('global:enum.License.eTO'),
    [License.eUMSATZMIETE]: t('global:enum.License.eUMSATZMIETE'),
    [License.eUNBESCHRAENKTE_DCL_ZEILEN]: t('global:enum.License.eUNBESCHRAENKTE_DCL_ZEILEN'),
    [License.eUNBESCHRAENKTE_FLAECHENVERWALTUNG]: t('global:enum.License.eUNBESCHRAENKTE_FLAECHENVERWALTUNG'),
    [License.eUST_FLAECHENAUFTEILUNG]: t('global:enum.License.eUST_FLAECHENAUFTEILUNG'),
    [License.eVERAENDERUNGSPROTOKOLL]: t('global:enum.License.eVERAENDERUNGSPROTOKOLL'),
    [License.eVERWALTUNGSABRECHNUNG_GLOBAL]: t('global:enum.License.eVERWALTUNGSABRECHNUNG_GLOBAL'),
    [License.eZAHLSCHEINDRUCK]: t('global:enum.License.eZAHLSCHEINDRUCK'),
    [License.eSERIENBRIEF_WORD]: t('global:enum.License.eSERIENBRIEF_WORD'),
    [License.eWEG_VERWALTUNG]: t('global:enum.License.eWEG_VERWALTUNG'),
    [License.eTECHNISCHE_BESTANDSDOKUMENTATION]: t('global:enum.License.eTECHNISCHE_BESTANDSDOKUMENTATION'),
    [License.eCMR]: t('global:enum.License.eCMR'),
    [License.eFREMD_WRNG]: t('global:enum.License.eFREMD_WRNG'),
    [License.eVA_PRINZIP_PERSON]: t('global:enum.License.eVA_PRINZIP_PERSON'),
    [License.eQW_SOLLSTELLUNG]: t('global:enum.License.eQW_SOLLSTELLUNG'),
    [License.eBESCHLUSSVERWALTUNG]: t('global:enum.License.eBESCHLUSSVERWALTUNG'),
    [License.eRECHNUNGSEINGANGSBUCH]: t('global:enum.License.eRECHNUNGSEINGANGSBUCH'),
    [License.eSCHNITTSTELLE_GDPDU]: t('global:enum.License.eSCHNITTSTELLE_GDPDU'),
    [License.eEXCEL_REPORTING]: t('global:enum.License.eEXCEL_REPORTING'),
    [License.eHKDE898]: t('global:enum.License.eHKDE898'),
    [License.eFLOWFACT]: t('global:enum.License.eFLOWFACT'),
    [License.ePRINTVIEWERPLUS]: t('global:enum.License.ePRINTVIEWERPLUS'),
    [License.eDATENBANKPROTOKOLL]: t('global:enum.License.eDATENBANKPROTOKOLL'),
    [License.eKOMFORTPAKET]: t('global:enum.License.eKOMFORTPAKET'),
    [License.eINABHINUNFRUECK]: t('global:enum.License.eINABHINUNFRUECK'),
    [License.eCASHFLOW]: t('global:enum.License.eCASHFLOW'),
    [License.eEINZELWERTBERICHTIGUNG]: t('global:enum.License.eEINZELWERTBERICHTIGUNG'),
    [License.eTRIMAHNSCHNITTSTELLE]: t('global:enum.License.eTRIMAHNSCHNITTSTELLE'),
    [License.eKOMFORTPAKETNURIS]: t('global:enum.License.eKOMFORTPAKETNURIS'),
    [License.eVA_PRINZIP_KREDITOR]: t('global:enum.License.eVA_PRINZIP_KREDITOR'),
    [License.eBENUTZERKOPPLUNG]: t('global:enum.License.eBENUTZERKOPPLUNG'),
    [License.eMIETVERTRAGSSCHREIBUNG]: t('global:enum.License.eMIETVERTRAGSSCHREIBUNG'),
    [License.eDOCUWAREINTEGRATION]: t('global:enum.License.eDOCUWAREINTEGRATION'),
    [License.eEBILANZ_SCHNITTSTELLE]: t('global:enum.License.eEBILANZ_SCHNITTSTELLE'),
    [License.eDATEV_PREMIUM_SCHNITTSTELLE]: t('global:enum.License.eDATEV_PREMIUM_SCHNITTSTELLE'),
    [License.eOS_DMS_OPTIMAL_SYSTEMS]: t('global:enum.License.eOS_DMS_OPTIMAL_SYSTEMS'),
    [License.eVERWALTERGEBUEHRENABR]: t('global:enum.License.eVERWALTERGEBUEHRENABR'),
    [License.eTAPI_SCHNITTSTELLE]: t('global:enum.License.eTAPI_SCHNITTSTELLE'),
    [License.eKM_KAUTIONSSCHNITTSTELLE]: t('global:enum.License.eKM_KAUTIONSSCHNITTSTELLE'),
    [License.eVIRTUELLE_KONTEN]: t('global:enum.License.eVIRTUELLE_KONTEN'),
    [License.eMITGLIEDERVERWALTUNG]: t('global:enum.License.eMITGLIEDERVERWALTUNG'),
    [License.eRECHNUNGSIMPORT]: t('global:enum.License.eRECHNUNGSIMPORT'),
    [License.eMYIMMOCONNECT_MIETER]: t('global:enum.License.eMYIMMOCONNECT_MIETER'),
    [License.eMYIMMOCONNECT_HAUSMEISTER]: t('global:enum.License.eMYIMMOCONNECT_HAUSMEISTER'),
    [License.eMYIMMOCONNECT_INVESTOR]: t('global:enum.License.eMYIMMOCONNECT_INVESTOR'),
    [License.eUSTVA_ELSTER]: t('global:enum.License.eUSTVA_ELSTER'),
    [License.eKAUTION_ZAHLUNGSVERKEHR]: t('global:enum.License.eKAUTION_ZAHLUNGSVERKEHR'),
    [License.eCASAVI_MIETER]: t('global:enum.License.eCASAVI_MIETER'),
    [License.eCASAVI_HAUSMEISTER]: t('global:enum.License.eCASAVI_HAUSMEISTER'),
    [License.eCASAVI_INVESTOR]: t('global:enum.License.eCASAVI_INVESTOR'),
    [License.eIXDWVIEW]: t('global:enum.License.eIXDWVIEW'),
    [License.eEASYDMSINTEGRATION]: t('global:enum.License.eEASYDMSINTEGRATION'),
    [License.eSERDMSINTEGRATION]: t('global:enum.License.eSERDMSINTEGRATION'),
    [License.eKONFIPAY]: t('global:enum.License.eKONFIPAY'),
    [License.eDATEV_PREMIUM_DMSBELEGEXPORT]: t('global:enum.License.eDATEV_PREMIUM_DMSBELEGEXPORT'),
    [License.eDMS_SUCHE]: t('global:enum.License.eDMS_SUCHE'),
    [License.eDMS_VERSCHLAGWORTUNG]: t('global:enum.License.eDMS_VERSCHLAGWORTUNG'),
    [License.eDMS_API]: t('global:enum.License.eDMS_API'),
    [License.eZAEHLERSTANDVERWALTUNG]: t('global:enum.License.eZAEHLERSTANDVERWALTUNG'),
    [License.eKAUTION_ZAHLUNGSVERKEHR_DKB]: t('global:enum.License.eKAUTION_ZAHLUNGSVERKEHR_DKB'),
    [License.ePROJEKT_RUECKSTELLUNGEN]: t('global:enum.License.ePROJEKT_RUECKSTELLUNGEN'),
    [License.eWOHNUNGSUEBERGABE_ENTAB]: t('global:enum.License.eWOHNUNGSUEBERGABE_ENTAB'),
    [License.eERWERBERVERWALTUNG]: t('global:enum.License.eERWERBERVERWALTUNG'),
    [License.eBERICHTSPAKET_5BERICHTE]: t('global:enum.License.eBERICHTSPAKET_5BERICHTE'),
    [License.eBERICHTSPAKET_10BERICHTE]: t('global:enum.License.eBERICHTSPAKET_10BERICHTE'),
    [License.eBERICHTSPAKET_UNBEGRENZT]: t('global:enum.License.eBERICHTSPAKET_UNBEGRENZT'),
    [License.eDATEV_SACHKONTEN_BUCHUNGSIMPORT]: t('global:enum.License.eDATEV_SACHKONTEN_BUCHUNGSIMPORT'),
    [License.eCOVID19_RATE_STUNDUNG_KOMFORTLOESUNG]: t('global:enum.License.eCOVID19_RATE_STUNDUNG_KOMFORTLOESUNG'),
    [License.eZENSUS_PREMIUM]: t('global:enum.License.eZENSUS_PREMIUM'),
    [License.eFEATUREPAKET_2020]: t('global:enum.License.eFEATUREPAKET_2020'),
    [License.eFEATUREPAKET_2021]: t('global:enum.License.eFEATUREPAKET_2021'),
    [License.eEGECKODMSINTEGRATION]: t('global:enum.License.eEGECKODMSINTEGRATION'),
    [License.eDATEV_RECHNUNGSIMPORT]: t('global:enum.License.eDATEV_RECHNUNGSIMPORT'),
    [License.eBISONBOX_EXPORT]: t('global:enum.License.eBISONBOX_EXPORT'),
    [License.eSCHLUESSELVERWALTUNG]: t('global:enum.License.eSCHLUESSELVERWALTUNG'),
    [License.eDYNTAB_M]: t('global:enum.License.eDYNTAB_M'),
    [License.eDYNTAB_L]: t('global:enum.License.eDYNTAB_L'),
    [License.eDYNTAB_XL]: t('global:enum.License.eDYNTAB_XL'),
    [License.eHKD_SCHNITTSTELLE_EED]: t('global:enum.License.eHKD_SCHNITTSTELLE_EED'),
    [License.eINTREAL_SCHNITTSTELLE_VERSION_4_5]: t('global:enum.License.eINTREAL_SCHNITTSTELLE_VERSION_4_5'),
    [License.eFEATUREPAKET_2022]: t('global:enum.License.eFEATUREPAKET_2022'),
    [License.eCASAVI_EED]: t('global:enum.License.eCASAVI_EED'),
    [License.eVA_PRINZIP_FLAECHE]: t('global:enum.License.eVA_PRINZIP_FLAECHE'),
    [License.eGRUNDSTEUER_DATEN]: t('global:enum.License.eGRUNDSTEUER_DATEN'),
    [License.eGRUNDSTEUER_BERECHNUNG]: t('global:enum.License.eGRUNDSTEUER_BERECHNUNG'),
    [License.eGRUNDSTEUER_ELSTEREXPORT]: t('global:enum.License.eGRUNDSTEUER_ELSTEREXPORT'),
    [License.eWEBSERVICEHKDDOK]: t('global:enum.License.eWEBSERVICEHKDDOK'),
    [License.eSCRIPTMENUERWEITERT]: t('global:enum.License.eSCRIPTMENUERWEITERT'),
    [License.eENERGIEAUSWEIS]: t('global:enum.License.eENERGIEAUSWEIS'),
    [License.eDOCUWARECONNECT2IXHAUSCLOUD]: t('global:enum.License.eDOCUWARECONNECT2IXHAUSCLOUD'),
    [License.eFEATUREPAKET_2023]: t('global:enum.License.eFEATUREPAKET_2023'),
    [License.eDATEIUMSTELLUNGEXCEL]: t('global:enum.License.eDATEIUMSTELLUNGEXCEL'),
    [License.eSCHNITTSTELLE_DATEV_WEBSERVICE]: t('global:enum.License.eSCHNITTSTELLE_DATEV_WEBSERVICE'),
    [License.eFEATUREPAKET_2024]: t('global:enum.License.eFEATUREPAKET_2024'),
    [License.eSEMPPM_SCHNITTSTELLE_VERSION_2_1]: t('global:enum.License.eSEMPPM_SCHNITTSTELLE_VERSION_2_1'),
    [License.eSEMPPM_SCHNITTSTELLE_VERSION_2_3]: t('global:enum.License.eSEMPPM_SCHNITTSTELLE_VERSION_2_3'),
    [License.eHANSAINVEST_SCHNITTSTELLE]: t('global:enum.License.eHANSAINVEST_SCHNITTSTELLE'),
    [License.eVA_PRINZIP_PROJEKTBUDGET]: t('global:enum.License.eVA_PRINZIP_PROJEKTBUDGET'),
    [License.ePLATZHALTER_FUER_NEUE_LIZENZ]: t('global:enum.License.ePLATZHALTER_FUER_NEUE_LIZENZ'),
    [License.eSSO_LOGIN]: t('global:enum.License.eSSO_LOGIN'),
    [License.eERECHNUNG_READY]: t('global:enum.License.eERECHNUNG_READY'),
}

export const licenseToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in License) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(LicenseLabels[License[x as keyof typeof License]]),
            value: License[x as keyof typeof License]
        })
    }

    return opts
}
